import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './Header.css';

const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const publicUrl = process.env.PUBLIC_URL || '';
  const headerLogoSources = [
    `${publicUrl}/logo-deitada.png`,
    `${publicUrl}/logo%20deitado.png`,
    `${publicUrl}/logo.webp`,
    `${publicUrl}/logo.png`
  ];

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  const handleSectionClick = (e, sectionId) => {
    const onHome = window.location.pathname === '/';
    if (onHome) {
      e.preventDefault();
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.history.replaceState(null, '', `/#${sectionId}`);
    }
    setMobileMenuOpen(false);
  };

  useEffect(() => {
    if (!mobileMenuOpen) return;
    const closeOnResize = () => {
      if (window.innerWidth >= 1081) setMobileMenuOpen(false);
    };
    window.addEventListener('resize', closeOnResize);
    return () => window.removeEventListener('resize', closeOnResize);
  }, [mobileMenuOpen]);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo" onClick={() => setMobileMenuOpen(false)}>
          <img 
            src={headerLogoSources[0]}
            alt="Navarro & Vieira Advogados" 
            className="logo-image"
            data-logo-index="0"
            onError={(e) => {
              const img = e.target;
              const currentIndex = Number.parseInt(img.dataset.logoIndex || '0', 10);
              const nextIndex = currentIndex + 1;
              if (nextIndex < headerLogoSources.length) {
                img.dataset.logoIndex = String(nextIndex);
                img.src = headerLogoSources[nextIndex];
                return;
              }
              img.style.display = 'none';
              const h1 = img.nextElementSibling;
              if (h1) h1.style.display = 'block';
            }}
          />
          <span className="logo-text-fallback">NAVARRO & VIEIRA</span>
        </Link>

        <button
          type="button"
          className="header-hamburger"
          aria-label={mobileMenuOpen ? 'Fechar menu' : 'Abrir menu'}
          aria-expanded={mobileMenuOpen}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <span className="hamburger-line" />
          <span className="hamburger-line" />
          <span className="hamburger-line" />
        </button>

        <div
          className={`header-nav-wrap ${mobileMenuOpen ? 'mobile-open' : ''}`}
          onClick={(e) => { if (e.target.closest('a')) setMobileMenuOpen(false); }}
        >
        <nav className="nav" aria-label="Menu principal">
          <Link to="/#areas-atuacao" onClick={(e) => handleSectionClick(e, 'areas-atuacao')}>Áreas de atuação</Link>
          <Link to="/#sobre-nos" onClick={(e) => handleSectionClick(e, 'sobre-nos')}>O escritório</Link>
          <Link to="/#advogados" onClick={(e) => handleSectionClick(e, 'advogados')}>Equipe</Link>
          <Link to="/guias">Guias</Link>
          <Link to="/noticias">Notícias</Link>
          <Link to="/#contato" onClick={(e) => handleSectionClick(e, 'contato')}>Contato</Link>
          <Link to="/#contato" className="nav-cta" onClick={(e) => handleSectionClick(e, 'contato')}>Fale conosco</Link>
        </nav>

        {user && (
          <div className="header-auth">
            <div className="user-menu">
              <button type="button" className="user-menu-trigger">
                <strong>{user.username}</strong>
              </button>
              <div className="user-dropdown">
                {user.isAdmin && (
                  <Link to="/admin/painel" className="user-dropdown-link">
                    Painel
                  </Link>
                )}
                <button onClick={handleLogout} className="btn-logout">
                  Sair
                </button>
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
    </header>
  );
};

export default Header;

